import { cloneElement } from "react"

const render = ({ providers, drilling, children }) => {
    const [provider, ...restProviders] = providers

    if (provider) {
        return cloneElement(
            provider,
            drilling ? provider.props : {},
            render({ providers: restProviders, drilling, children })
        )
    }

    return children
}

export default function combine({ providers, drilling = false }) {
    return function MasterProvider({ children }) {
        return render({ providers, drilling, children })
    }
}
